import api from '../../utils/api';

export const fetchWishlist = async () => {
  const response = await api.get('/wishlist');
  const wishlist = response.data.data;
  return { items: wishlist.products || [] };
};

export const toggleWishlist = async (productId) => {
  const response = await api.post('/wishlist/toggle', { productId });
  const result = response.data.data;
  return {
    items: result.wishlist.products || [],
    added: result.action === 'added',
  };
};

export const checkInWishlist = async (productId) => {
  const response = await api.get(`/wishlist/check/${productId}`);
  return { inWishlist: response.data.data.isIn };
};
